import React from 'react';
import type { ButtonBlockContent } from '../../../types/popup.types';

interface ButtonBlockProps {
  content: ButtonBlockContent;
}

const ButtonBlock: React.FC<ButtonBlockProps> = ({ content }) => {
  const { text, url, style, size, fullWidth, borderRadius } = content;

  const buttonClass = `btn btn-${style || 'primary'} btn-${size || 'lg'} fw-bold${
    fullWidth ? ' w-100' : ''
  }`;

  return (
    <div className="d-flex justify-content-center my-4">
      <a
        href={url}
        className={buttonClass}
        style={{ borderRadius: `${borderRadius || 8}px`, textDecoration: 'none' }}
      >
        {text}
      </a>
    </div>
  );
};

export default ButtonBlock;
